import candidateApi from './api';

export const getEducations = async () => {
  try {
    const response = await candidateApi.get('/education');
    return response.data;
  } catch (error) {
    console.error('Error fetching education:', error);
    throw error;
  }
};

export const createEducation = async (educationData) => {
  try {
    const response = await candidateApi.post('/education/create', educationData);
    return response.data;
  } catch (error) {
    console.error('Error creating education:', error);
    throw error;
  }
};

export const updateEducation = async (id, educationData) => {
  try {
    const response = await candidateApi.put(`/education/${id}`, educationData);
    return response.data;
  } catch (error) {
    console.error('Error updating education:', error);
    throw error;
  }
};

export const deleteEducation = async (id) => {
  try {
    const response = await candidateApi.delete(`/education/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting education:', error);
    throw error;
  }
};